import { LockUnlocked01, Trash01 } from "@untitledui/icons";
import ModalBase from "@/components/ui/modal/modal-base";
import { useToast } from "@/providers/toast-provider";
import { useUpdateUserStatusMutation } from "../hooks";
import type { DeleteUserProps } from "../types";

export const DeleteUser = ({
	isOpen,
	onClose,
	user,
	onSuccess,
}: DeleteUserProps) => {
	const { showToast } = useToast();
	const { mutateAsync, isPending } = useUpdateUserStatusMutation();

	const isDeleting = user?.isActive;

	const handleToggleStatus = async () => {
		if (!user?.id) {
			return;
		}

		const newStatus = !user.isActive;

		try {
			await mutateAsync({
				userId: user.id,
				data: { isActive: newStatus },
			});

			showToast({
				title: newStatus ? "Usuário ativado" : "Usuário desativado",
				variant: newStatus ? "success" : "error",
				description: newStatus
					? `${user.name} agora está ativo no sistema.`
					: `${user.name} foi desativado e não terá mais acesso.`,
			});

			onClose();
			onSuccess?.();
		} catch {
			showToast({
				title: "Erro ao atualizar",
				variant: "error",
				description: "Não foi possível atualizar o usuário. Tente novamente.",
			});
		}
	};

	return (
		<ModalBase
			actions={[
				{
					label: "Cancelar",
					onClick: onClose,
					color: "secondary",
					disabled: isPending,
				},
				{
					label: isDeleting ? "Desativar" : "Ativar",
					onClick: handleToggleStatus,
					color: isDeleting ? "primary-destructive" : "primary",
					disabled: isPending,
				},
			]}
			description={
				isDeleting
					? "O usuário será desativado e perderá acesso ao sistema. Deseja continuar?"
					: "O usuário será reativado e poderá acessar novamente o sistema. Deseja continuar?"
			}
			height="254px"
			icon={isDeleting ? <Trash01 /> : <LockUnlocked01 />}
			iconColor={isDeleting ? "error" : "success"}
			isOpen={isOpen}
			onClose={onClose}
			title={isDeleting ? "Desativar usuário" : "Ativar usuário"}
			width="400px"
		/>
	);
};
